import { ProductAccountingCategoryListPage } from '@/features/product-accounting-category/pages/ProductAccountingCategoryListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-accounting-category/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_accounting_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAccountingCategoryListPage,
})